(function () {
	"use strict";

	// Rooted by id, not the .lp-patch-landing class, to match this theme's
	// convention for pages with their own JS (see lp-bedtime-stickers-v1.js.liquid) —
	// keeps this script safe even if another wrapper ever shares the class.
	var root = document.getElementById("lpPatchLanding");
	if (!root) return;

	var $ = function (sel, ctx) {
		return (ctx || root).querySelector(sel);
	};
	var $$ = function (sel, ctx) {
		return Array.prototype.slice.call((ctx || root).querySelectorAll(sel));
	};

	var CURRENCY = root.getAttribute("data-currency") || "USD";
	var PRODUCT_NAME = root.getAttribute("data-product-name") || "product";
	function money(cents) {
		var amount = (parseInt(cents, 10) || 0) / 100;
		if (window.Intl && typeof Intl.NumberFormat === "function") {
			try {
				return new Intl.NumberFormat(document.documentElement.lang || undefined, {
					style: "currency",
					currency: CURRENCY,
					currencyDisplay: "narrowSymbol"
				}).format(amount);
			} catch (e) {
				/* unsupported currency code — fall through */
			}
		}
		return "$" + amount.toFixed(2);
	}

	// ---------- gallery ----------
	var galMain = $("#galMain");
	var galContainer = $(".gal__main");
	var galVideo = $("#galVideo");
	if (!galVideo && galContainer) {
		galVideo = document.createElement("video");
		galVideo.id = "galVideo";
		galVideo.playsInline = true;
		galVideo.loop = true;
		galVideo.controls = true;
		galVideo.style.width = "100%";
		galVideo.style.height = "100%";
		galVideo.style.objectFit = "cover";
		galVideo.style.display = "none";
		galVideo.style.transition = "opacity .18s ease";
		galContainer.appendChild(galVideo);
	}

	// "How to Apply" gallery thumb (optional, only when the wrapper passes
	// how_to_apply_youtube_id) — a YouTube URL is never a direct video file,
	// so it gets its own iframe rather than reusing galVideo's own video
	// element.
	var galYoutube = null;
	function ensureGalYoutube() {
		if (!galYoutube && galContainer) {
			galYoutube = document.createElement("iframe");
			galYoutube.id = "galYoutube";
			galYoutube.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
			galYoutube.setAttribute("allowfullscreen", "");
			galYoutube.style.display = "none";
			galYoutube.style.width = "100%";
			galYoutube.style.height = "100%";
			galYoutube.style.border = "0";
			galContainer.appendChild(galYoutube);
		}
		return galYoutube;
	}
	function hideGalYoutube() {
		if (galYoutube) {
			galYoutube.style.display = "none";
			galYoutube.src = "";
		}
	}

	function isVideoUrl(url) {
		return /\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(url || "");
	}

	function updateVideoThumb(btn) {
		var full = btn.getAttribute("data-full");
		if (!isVideoUrl(full)) return;
		if (btn.getAttribute("data-thumb-loaded") === full) return;

		var img = btn.querySelector("img");
		if (!img) {
			img = document.createElement("img");
			img.alt = "";
			img.style.opacity = "0";
			img.style.transition = "opacity .25s ease";
			btn.appendChild(img);
		}

		var v = document.createElement("video");
		v.crossOrigin = "anonymous";
		v.muted = true;
		v.playsInline = true;
		v.preload = "metadata";
		v.src = full;

		var done = false;
		function finish() {
			if (done) return;
			done = true;
			try {
				var c = document.createElement("canvas");
				c.width = v.videoWidth || 360;
				c.height = v.videoHeight || 360;
				var ctx = c.getContext("2d");
				ctx.drawImage(v, 0, 0, c.width, c.height);
				img.src = c.toDataURL("image/jpeg", 0.85);
				img.style.opacity = "1";
				btn.setAttribute("data-thumb-loaded", full);
			} catch (err) {
				btn.innerHTML = "";
				var vidFallback = document.createElement("video");
				vidFallback.src = full + "#t=0.5";
				vidFallback.muted = true;
				vidFallback.playsInline = true;
				vidFallback.preload = "metadata";
				vidFallback.style.width = "100%";
				vidFallback.style.height = "100%";
				vidFallback.style.objectFit = "cover";
				vidFallback.style.pointerEvents = "none";
				btn.appendChild(vidFallback);
				btn.setAttribute("data-thumb-loaded", full);
			}
		}

		v.addEventListener("loadedmetadata", function () {
			v.currentTime = Math.min(1.0, (v.duration || 1.0) / 2);
		});
		v.addEventListener("seeked", finish);
		v.addEventListener("loadeddata", function () {
			if (v.currentTime === 0) {
				v.currentTime = Math.min(1.0, (v.duration || 1.0) / 2);
			}
		});
		v.addEventListener("error", function () {
			if (!done) finish();
		});
		setTimeout(finish, 3500);
	}

	var thumbButtons = $$(".gal__thumbs button");
	thumbButtons.forEach(updateVideoThumb);

	if (window.MutationObserver) {
		var thumbObserver = new MutationObserver(function (mutations) {
			mutations.forEach(function (m) {
				if (m.type === "attributes" && m.attributeName === "data-full") {
					m.target.removeAttribute("data-thumb-loaded");
					updateVideoThumb(m.target);
				}
			});
		});
		thumbButtons.forEach(function (b) {
			thumbObserver.observe(b, { attributes: true, attributeFilter: ["data-full"] });
		});
	}

	thumbButtons.forEach(function (btn) {
		btn.addEventListener("click", function () {
			thumbButtons.forEach(function (b) {
				b.classList.remove("on");
			});
			btn.classList.add("on");
			var full = btn.getAttribute("data-full");
			if (!full) return;

			hideGalYoutube();

			if (isVideoUrl(full)) {
				if (galMain) galMain.style.opacity = "0";
				setTimeout(function () {
					if (galMain) galMain.style.display = "none";
					if (galVideo) {
						galVideo.style.display = "block";
						galVideo.style.opacity = "0";
						if (galVideo.getAttribute("src") !== full) {
							galVideo.src = full;
							galVideo.load();
						}
						galVideo.currentTime = 0;
						var p = galVideo.play();
						if (p !== undefined) {
							p.catch(function () {
								galVideo.muted = true;
								galVideo.play().catch(function () {});
							});
						}
						setTimeout(function () {
							galVideo.style.opacity = "1";
						}, 20);
					}
				}, 140);
			} else {
				if (galVideo) {
					galVideo.pause();
					galVideo.style.opacity = "0";
				}
				if (galMain) galMain.style.opacity = "0";
				setTimeout(function () {
					if (galVideo) galVideo.style.display = "none";
					if (galMain) {
						galMain.style.display = "block";
						galMain.src = full;
						galMain.style.opacity = "1";
					}
				}, 140);
			}
		});
	});

	$$(".gal__thumbs [data-yt]").forEach(function (btn) {
		btn.addEventListener("click", function () {
			thumbButtons.forEach(function (b) {
				b.classList.remove("on");
			});
			btn.classList.add("on");
			var id = btn.getAttribute("data-yt");
			if (!id) return;
			var frame = ensureGalYoutube();
			if (!frame) return;
			if (galVideo) {
				galVideo.pause();
				galVideo.style.display = "none";
			}
			if (galMain) galMain.style.display = "none";
			frame.src = "https://www.youtube.com/embed/" + id + "?autoplay=1&rel=0";
			frame.style.display = "block";
		});
	});

	// ---------- live purchase engine ----------
	// Pack rows (div.lprow) and plan cards (div.plan2 > div) are plain divs, not
	// buttons — the subscribe card holds a real frequency select element, and
	// a select cannot nest inside a button per the HTML content model. role="radio"
	// + tabindex keeps both keyboard-operable; see the keydown handler below.
	//
	// SEGMENTED PRODUCTS (optional "For kids / For adults" etc, via #segToggle):
	// each segment gets its own .seg-panel[data-seg-panel] with its own pack
	// rows / plan cards / frequency select / plan-map JSON, server-rendered
	// from that segment's own product — a genuinely different product+price,
	// not a relabeled one. `pe` (purchase-engine scope) always points at the
	// CURRENTLY VISIBLE panel's elements; bindPurchaseScope() re-resolves it
	// on load and again every time the segment switches. Pages with no
	// #segToggle render exactly one implicit panel, so this is a no-op
	// generalization for them — same single pack/plan flow as before.
	var segEl = $("#segToggle");
	var segPanels = $$(".seg-panel");

	function activePanel() {
		if (!segPanels.length) return root;
		return segPanels.filter(function (p) { return !p.hidden; })[0] || segPanels[0];
	}

	var pe = {};
	var state = { pack: null, plan: "one-time", addon: false };

	var idInput = $("#zpVariantId");
	var addonEl = $("#addon");
	var addonIdInput = $("[data-addon-id]");
	var addonQtyInput = $("[data-addon-qty]");
	var addonCents = addonEl ? parseInt(addonEl.getAttribute("data-addon-cents"), 10) || 0 : 0;
	var totalLabelEl = $("[data-total-label]");
	var totalPriceEl = $("#totalPrice");
	var totalSaveEl = $("#totalSave");
	var buyCtaEl = $("#buyCta");
	var sbarTitleEl = $("#sbarTitle");
	// Nav + closing-section "Get X · price" links — mirror the buy-box
	// selection's total, same as #buyCta.
	var selPriceCtaEls = $$("[data-sel-price-cta]");

	// Re-resolves every per-segment element from whichever panel is currently
	// visible, and resets pack/plan state to that panel's own server-rendered
	// default (each panel already marks its own default pack ".on" and
	// subscribe-vs-one-time card ".on", same as the single-panel case always
	// has). Called once at init and again on every segment switch.
	function bindPurchaseScope() {
		var scope = activePanel();

		// A segment switch away from a panel where the shopper had a real,
		// valid Subscribe & Save selection leaves that panel's own select
		// still carrying name="items[0][selling_plan]" — render() below only
		// ever updates the NEWLY active panel's select, never one it just
		// left. Left alone, a native form submit sends BOTH selects' values
		// under the same field name, silently attaching the OLD segment's
		// selling plan id to whichever variant id the shopper actually just
		// chose. Force every select back to disabled/nameless here, before
		// the active one gets its own real state applied below.
		$$("select[data-plan-input]").forEach(function (sel) {
			sel.disabled = true;
			sel.removeAttribute("name");
		});

		pe.packRoot = scope.querySelector("[data-pack-rows]");
		pe.planRoot = scope.querySelector("[data-plan-rows]");
		pe.packRows = $$(".lprow", pe.packRoot);
		pe.subscribeCard = pe.planRoot ? pe.planRoot.querySelector('[data-plan="subscribe"]') : null;
		pe.onetimeCard = pe.planRoot ? pe.planRoot.querySelector('[data-plan="one-time"]') : null;
		pe.planCards = [pe.subscribeCard, pe.onetimeCard].filter(Boolean);
		pe.planSelect = scope.querySelector("select[data-plan-input]");
		pe.planSelectWrap = pe.planSelect ? pe.planSelect.closest(".cad__change-wrap") : null;
		pe.cadValueEl = scope.querySelector("[data-cad-value]");
		pe.cadCommonEl = scope.querySelector("[data-cad-common]");
		pe.planMapEl = scope.querySelector("[data-plan-map]");
		try {
			pe.planMap = pe.planMapEl ? JSON.parse(pe.planMapEl.textContent) : null;
		} catch (e) {
			pe.planMap = null;
		}
		pe.lastPlanVariant = null;
		pe.oneTimePriceEl = scope.querySelector("[data-onetime-price]");
		pe.oneTimePriceOnlyEl = scope.querySelector("[data-onetime-price2]");
		pe.subPriceEl = scope.querySelector("[data-sub-price]");
		pe.subPriceOnlyEl = scope.querySelector("[data-sub-price2]");
		pe.subFlagEl = scope.querySelector("[data-plan-flag]");
		pe.ribbonEl = scope.querySelector("[data-plan-ribbon]");
		pe.saveLineEl = scope.querySelector("[data-plan-save-line]");
		pe.cadEl = scope.querySelector(".cad");
		pe.cadLabelEl = scope.querySelector("[data-cad-label]");

		var initialRow = pe.packRoot ? pe.packRoot.querySelector(".lprow.on") || pe.packRows[0] : pe.packRows[0];
		state.pack = initialRow ? initialRow.getAttribute("data-pack") : null;
		state.plan = pe.subscribeCard && pe.subscribeCard.classList.contains("on") ? "subscribe" : "one-time";
	}

	function activeRow() {
		return (pe.packRoot && pe.packRoot.querySelector('.lprow[data-pack="' + state.pack + '"]')) || pe.packRows[0];
	}

	// Rebuilds the frequency select's options from planMap[variantId] — only
	// when the pack actually changed. Tries to keep the shopper's chosen
	// frequency by NAME (ids differ per variant), else "Every 2 Months", else
	// the first option — same convention as lp-bedtime-stickers-buybox.js.liquid.
	function repopulatePlans(variantId) {
		if (!pe.planSelect || !pe.planMap || variantId === pe.lastPlanVariant) return;
		var currentName = pe.planSelect.selectedOptions[0] ? pe.planSelect.selectedOptions[0].textContent : null;
		pe.lastPlanVariant = variantId;
		var list = pe.planMap[variantId] || [];
		pe.planSelect.innerHTML = "";
		var matchIdx = -1,
			defIdx = -1;
		list.forEach(function (p, i) {
			var o = document.createElement("option");
			o.value = p.id;
			o.setAttribute("data-pct", p.pct);
			o.textContent = (p.name || "").replace(/^every\s+/i, "");
			pe.planSelect.appendChild(o);
			if (currentName && o.textContent === currentName) matchIdx = i;
			if (0 > defIdx && /every\s*2\s*month/i.test(p.name || "")) defIdx = i;
		});
		if (list.length) pe.planSelect.selectedIndex = matchIdx >= 0 ? matchIdx : defIdx >= 0 ? defIdx : 0;
		if (pe.planSelectWrap) pe.planSelectWrap.style.display = list.length > 1 ? "" : "none";
	}

	function selectedPlanPct() {
		var opt = pe.planSelect ? pe.planSelect.selectedOptions[0] : null;
		return opt ? parseInt(opt.getAttribute("data-pct"), 10) || 0 : 0;
	}

	// Every pack tile's displayed price follows the Subscribe/One-time toggle,
	// not just the summary line below the grid.
	function updatePackTiles(activeVariantId, activeSubscribeCents) {
		pe.packRows.forEach(function (row) {
			var isActive = row.getAttribute("data-variant-id") === activeVariantId;
			var oc = parseInt(row.getAttribute("data-onetime-cents"), 10) || 0;
			var sc = isActive ? activeSubscribeCents : parseInt(row.getAttribute("data-subscribe-cents"), 10) || 0;
			var cc = parseInt(row.getAttribute("data-compare-cents"), 10) || 0;
			var shown = state.plan === "subscribe" ? sc : oc;

			var priceEl = row.querySelector(".pr");
			var strikeEl = row.querySelector(".pr s");
			var perDayEl = row.querySelector("small");
			var days = parseInt(row.getAttribute("data-days"), 10) || 1;

			if (priceEl && priceEl.firstChild) priceEl.firstChild.textContent = money(shown);
			if (strikeEl) {
				if (cc > shown) {
					strikeEl.textContent = money(cc);
					strikeEl.hidden = false;
				} else {
					strikeEl.hidden = true;
				}
			}
			if (perDayEl) {
				var note = row.getAttribute("data-pack-note");
				perDayEl.textContent = money(Math.round(shown / days)) + "/day" + (note ? " · " + note : "");
			}
		});
	}

	function render() {
		var row = activeRow();
		if (!row) return;

		var variantId = row.getAttribute("data-variant-id");
		var onetimeCents = parseInt(row.getAttribute("data-onetime-cents"), 10) || 0;
		var compareCents = parseInt(row.getAttribute("data-compare-cents"), 10) || 0;
		var pack = row.getAttribute("data-pack");
		var packLabel = pack + " pack" + (pack === "1" ? "" : "s");

		repopulatePlans(variantId);
		var hasRealPlan = !!(pe.planMap && pe.planMap[variantId] && pe.planMap[variantId].length);
		// Subscribe & Save availability is decided purely by whether THIS
		// variant actually carries a real selling-plan allocation — never a
		// hardcoded pack-size rule. An earlier version of this always
		// disabled it for the 1-pack variant regardless of the store's own
		// data, which was correct for ZenPatch/FocusPatch (their 1-packs
		// genuinely have no plan) but wrongly disabled it for SleepyPatch,
		// whose 1-pack DOES carry a real, intended Subscribe & Save plan.
		var hasPlan = hasRealPlan;

		// A pack that can't subscribe (no real plan) must not stay on
		// "subscribe": force one-time so the form never posts a plan id
		// this pack shouldn't offer.
		if (!hasPlan && state.plan === "subscribe") {
			state.plan = "one-time";
		}
		if (pe.subscribeCard) {
			pe.subscribeCard.style.display = hasRealPlan ? "" : "none";
			pe.subscribeCard.setAttribute("aria-disabled", "false");
			pe.subscribeCard.tabIndex = 0;
		}
		pe.planCards.forEach(function (card) {
			if (!card) return;
			var isOn = card.getAttribute("data-plan") === state.plan;
			card.classList.toggle("on", isOn);
			card.setAttribute("aria-checked", isOn ? "true" : "false");
		});

		var pct = hasRealPlan ? selectedPlanPct() : 0;
		var subscribeCents = Math.round((onetimeCents * (100 - pct)) / 100);
		var price = state.plan === "subscribe" ? subscribeCents : onetimeCents;

		if (idInput) idInput.value = variantId;
		if (pe.planSelect) {
			var isSub = state.plan === "subscribe" && hasPlan;
			if (isSub) {
				pe.planSelect.disabled = false;
				pe.planSelect.name = "items[0][selling_plan]";
			} else {
				pe.planSelect.disabled = true;
				pe.planSelect.removeAttribute("name");
			}
		}

		if (pe.oneTimePriceEl) pe.oneTimePriceEl.textContent = money(onetimeCents) + " · no commitment";
		if (pe.oneTimePriceOnlyEl) pe.oneTimePriceOnlyEl.textContent = money(onetimeCents);
		if (hasRealPlan) {
			if (pe.subPriceEl) pe.subPriceEl.textContent = money(subscribeCents) + " · skip or cancel anytime";
			if (pe.subPriceOnlyEl) pe.subPriceOnlyEl.textContent = money(subscribeCents);
			if (pe.subFlagEl) pe.subFlagEl.textContent = "Subscribe, save " + pct + "%";
			if (pe.ribbonEl) pe.ribbonEl.textContent = "Get Extra " + pct + "% Off";
			if (pe.saveLineEl) pe.saveLineEl.textContent = "✔ Save " + pct + "% on This and All Future Orders";
		}
		// The cadence bar's frequency control IS planSelect itself (moved
		// there in markup so there's one frequency picker, not two) — its
		// own selected option already shows the current value natively, so
		// there's nothing extra to write into the DOM here.
		var cadShown = state.plan === "subscribe" && hasPlan;
		if (pe.cadEl) pe.cadEl.hidden = !cadShown;
		if (pe.cadLabelEl) pe.cadLabelEl.hidden = !cadShown;
		if (pe.cadValueEl && pe.planSelect && pe.planSelect.selectedOptions[0]) {
			pe.cadValueEl.textContent = pe.planSelect.selectedOptions[0].textContent;
		}
		// "· most common" mirrors the same "every 2 month" preference the
		// Liquid side uses to pick the default plan — matched by NAME, not
		// id: a fixed id would go stale the moment repopulatePlans() above
		// rebuilds the select's options for a different pack (a different
		// variant, so different selling-plan ids even for the "same"
		// 2-month cadence).
		if (pe.cadCommonEl) {
			var selectedName = pe.planSelect && pe.planSelect.selectedOptions[0] ? pe.planSelect.selectedOptions[0].textContent : "";
			pe.cadCommonEl.hidden = !/2\s*months?/i.test(selectedName);
		}

		var addonOn = !!(addonEl && addonEl.classList.contains("on"));
		var total = price + (addonOn ? addonCents : 0);
		var compareTotal = (compareCents > 0 ? compareCents : onetimeCents) + (addonOn ? addonCents : 0);

		if (totalLabelEl) totalLabelEl.textContent = "Total for " + packLabel;
		if (totalPriceEl) totalPriceEl.textContent = money(total);
		if (totalSaveEl) {
			if (compareTotal > total) {
				var savePct = Math.round(((compareTotal - total) / compareTotal) * 100);
				totalSaveEl.textContent = "save " + money(compareTotal - total) + " (" + savePct + "%)";
				totalSaveEl.hidden = false;
			} else {
				totalSaveEl.hidden = true;
			}
		}
		if (buyCtaEl) buyCtaEl.textContent = "Get " + PRODUCT_NAME + " · " + money(total);
		selPriceCtaEls.forEach(function (el) {
			el.textContent = "Get " + PRODUCT_NAME + " · " + money(total);
		});
		if (sbarTitleEl) sbarTitleEl.textContent = packLabel + " · " + money(total);

		if (addonQtyInput) addonQtyInput.value = addonOn ? "1" : "0";
		if (addonIdInput) addonIdInput.disabled = !addonOn;
		if (addonQtyInput) addonQtyInput.disabled = !addonOn;

		updatePackTiles(variantId, subscribeCents);
	}

	function selectPack(pack) {
		state.pack = pack;
		pe.packRows.forEach(function (row) {
			var active = row.getAttribute("data-pack") === pack;
			row.classList.toggle("on", active);
			row.setAttribute("aria-checked", active ? "true" : "false");
		});
		render();
	}

	function selectPlan(plan) {
		state.plan = plan;
		render();
	}

	// Pack-row / plan-card listeners are bound ONCE per panel at init (panels
	// are static markup, never regenerated) and always act on `pe`/`state`,
	// i.e. whichever panel is active when the click actually happens — a
	// hidden panel's rows can't be clicked, so this is unambiguous.
	$$(".lprow").forEach(function (row) {
		row.addEventListener("click", function () {
			selectPack(row.getAttribute("data-pack"));
		});
		row.setAttribute("role", "radio");
		row.setAttribute("tabindex", "0");
		row.addEventListener("keydown", function (e) {
			if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
				e.preventDefault();
				selectPack(row.getAttribute("data-pack"));
			}
		});
	});

	$$(".plan2 > div").forEach(function (card) {
		card.setAttribute("role", "radio");
		card.setAttribute("tabindex", "0");
		card.addEventListener("click", function () {
			if (card.getAttribute("aria-disabled") === "true") return;
			selectPlan(card.getAttribute("data-plan"));
		});
		card.addEventListener("keydown", function (e) {
			if (e.target === pe.planSelect) return; // let the select handle its own keys
			if (card.getAttribute("aria-disabled") === "true") return;
			if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
				e.preventDefault();
				selectPlan(card.getAttribute("data-plan"));
			}
		});
	});

	$$("select[data-plan-input]").forEach(function (sel) {
		sel.addEventListener("click", function (e) {
			e.stopPropagation();
		});
		sel.addEventListener("change", function () {
			state.plan = "subscribe";
			render();
		});
	});

	// No click handler needed for "change ▾" — the real select sits
	// invisibly on top of it (.cad__freq-invisible, see the CSS file), so a
	// click on "change ▾" IS a native click on the select itself and opens
	// its dropdown right there, anchored correctly.

	if (addonEl) {
		addonEl.addEventListener("click", function () {
			addonEl.classList.toggle("on");
			addonEl.setAttribute("aria-checked", addonEl.classList.contains("on") ? "true" : "false");
			render();
		});
		addonEl.addEventListener("keydown", function (e) {
			if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
				e.preventDefault();
				addonEl.click();
			}
		});
	}

	bindPurchaseScope();

	// ---------- segmented control (optional, e.g. "For kids / For adults") ----------
	// Absent on pages that don't render #segToggle, so all of this is a
	// no-op there. Each option's data-seg must match a panel's
	// data-seg-panel — see lp-patch-landing-template.liquid.
	if (segEl && segPanels.length) {
		var segOptions = $$("span", segEl);
		segOptions.forEach(function (opt) {
			opt.addEventListener("click", function () {
				var key = opt.getAttribute("data-seg");
				segOptions.forEach(function (o) {
					o.classList.remove("on");
				});
				opt.classList.add("on");
				segPanels.forEach(function (p) {
					p.hidden = p.getAttribute("data-seg-panel") !== key;
				});
				bindPurchaseScope();
				render();
			});
		});
	}

	// ---------- direct to checkout (bypasses the iCart drawer) ----------
	// iCart's app embed binds ONE capture click listener on document.body and
	// hijacks any click inside `form[action*='/cart/add'] [type=submit]` —
	// #buyCta qualifies — preventing the native POST and opening its drawer
	// instead of letting return_to=/checkout run. A capture listener on
	// `document` always fires before one on document.body (capture runs
	// root-to-target by tree position), so handling the click here and
	// stopping propagation means iCart never sees it. Same fix, same
	// reasoning, as snippets/lp-purchase.liquid's DIRECT-TO-CHECKOUT block.
	//
	// Navigates /cart/clear -> /cart/add?items... -> /checkout as plain GETs
	// (no fetch), so there's no cart-updated event for iCart to react to,
	// and the checkout holds ONLY this page's selection. The line items are
	// read from the form's own enabled, named inputs — the same ones a native
	// submit would send — so pack, plan (selling_plan only when Subscribe is
	// really active) and add-on stay in sync with render() automatically.
	var cartForm = $("#zpCartForm");
	var ctaButtons = [$("#buyCta"), $("#sbarCta")].filter(Boolean);
	var checkoutStarted = false;
	var setCtaLoading = function (on) {
		ctaButtons.forEach(function (b) {
			b.classList.toggle("is-loading", on);
			if (on) b.setAttribute("aria-busy", "true");
			else b.removeAttribute("aria-busy");
			b.disabled = on;
		});
	};
	var checkoutUrl = function () {
		var items = {};
		var order = [];
		new FormData(cartForm).forEach(function (value, name) {
			var m = /^items\[(\d+)\]\[(\w+)\]$/.exec(name);
			if (!m || value === "") return;
			if (!items[m[1]]) {
				items[m[1]] = {};
				order.push(m[1]);
			}
			items[m[1]][m[2]] = value;
		});
		var parts = [];
		order.forEach(function (k) {
			var it = items[k];
			if (!it.id || !(parseInt(it.quantity, 10) >= 1)) return;
			parts.push("items[][id]=" + encodeURIComponent(it.id));
			parts.push("items[][quantity]=" + encodeURIComponent(it.quantity));
			if (it.selling_plan) parts.push("items[][selling_plan]=" + encodeURIComponent(it.selling_plan));
		});
		if (!parts.length) return null;
		var addPath = "/cart/add?" + parts.join("&") + "&return_to=/checkout";
		return "/cart/clear?return_to=" + encodeURIComponent(addPath);
	};
	var directCheckout = function (evt) {
		var url = checkoutUrl();
		if (!url) return; // malformed state: leave the native submit alone rather than navigate somewhere bad
		evt.preventDefault();
		evt.stopImmediatePropagation();
		if (checkoutStarted) return; // double-click guard
		checkoutStarted = true;
		setCtaLoading(true);
		window.location.href = url;
	};
	if (cartForm) {
		// Delegated on `document`, capture phase — see above. `contains()`
		// covers clicks on a descendant of a button, the same way iCart's own
		// walk-up-from-target matching does. #sbarCta is matched by id, so it
		// still works after the sticky bar is moved to document.body below.
		document.addEventListener("click", function (evt) {
			for (var i = 0; ctaButtons.length > i; i++) {
				var b = ctaButtons[i];
				if (!b.disabled && (evt.target === b || b.contains(evt.target))) {
					directCheckout(evt);
					return;
				}
			}
		}, true);
		// Enter-key / programmatic submits of the form itself.
		document.addEventListener("submit", function (evt) {
			if (evt.target === cartForm) directCheckout(evt);
		}, true);
	}
	// Back button from checkout restores this page from bfcache with the
	// buttons still in their loading state — reset them.
	window.addEventListener("pageshow", function (e) {
		if (!e.persisted) return;
		checkoutStarted = false;
		setCtaLoading(false);
	});

	render();

	// ---------- hero photo slider (only rendered with 2+ hero_photo_assets) ----------
	// Crossfade: every slide is stacked, .is-active sets opacity 1 (CSS).
	// Auto-advances every data-interval ms; pauses on hover/focus and while
	// the tab is hidden; any manual move (dot tap or swipe) restarts the
	// timer. Auto-advance is skipped for prefers-reduced-motion — dots and
	// swipe still work.
	var heroSlider = $("[data-hero-slider]");
	if (heroSlider) {
		var heroSlides = $$("img", heroSlider);
		var heroDots = $$("[data-hero-dot]", heroSlider);
		var heroIdx = 0;
		var heroTimer = null;
		var heroPaused = false;
		var heroInterval = parseInt(heroSlider.getAttribute("data-interval"), 10) || 5000;
		var heroReduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

		var heroGo = function (i) {
			var n = heroSlides.length;
			heroIdx = ((i % n) + n) % n;
			heroSlides.forEach(function (img, k) {
				var on = k === heroIdx;
				img.classList.toggle("is-active", on);
				if (on) img.removeAttribute("aria-hidden");
				else img.setAttribute("aria-hidden", "true");
			});
			heroDots.forEach(function (dot, k) {
				var on = k === heroIdx;
				dot.classList.toggle("is-active", on);
				if (on) dot.setAttribute("aria-current", "true");
				else dot.removeAttribute("aria-current");
			});
		};
		var heroStop = function () {
			if (heroTimer) clearInterval(heroTimer);
			heroTimer = null;
		};
		var heroStart = function () {
			heroStop();
			if (heroReduced || heroPaused || document.hidden) return;
			heroTimer = setInterval(function () {
				heroGo(heroIdx + 1);
			}, heroInterval);
		};

		heroDots.forEach(function (dot) {
			dot.addEventListener("click", function () {
				heroGo(parseInt(dot.getAttribute("data-hero-dot"), 10) || 0);
				heroStart();
			});
		});

		var heroTouchX = null;
		heroSlider.addEventListener("touchstart", function (e) {
			heroTouchX = e.touches[0].clientX;
		}, { passive: true });
		heroSlider.addEventListener("touchend", function (e) {
			if (heroTouchX === null) return;
			var dx = e.changedTouches[0].clientX - heroTouchX;
			heroTouchX = null;
			if (Math.abs(dx) >= 40) {
				heroGo(heroIdx + (dx > 0 ? -1 : 1));
				heroStart();
			}
		}, { passive: true });

		heroSlider.addEventListener("mouseenter", function () {
			heroPaused = true;
			heroStop();
		});
		heroSlider.addEventListener("mouseleave", function () {
			heroPaused = false;
			heroStart();
		});
		heroSlider.addEventListener("focusin", function () {
			heroPaused = true;
			heroStop();
		});
		heroSlider.addEventListener("focusout", function () {
			heroPaused = false;
			heroStart();
		});
		document.addEventListener("visibilitychange", heroStart);

		heroStart();
	}

	// ---------- how/faq accordions are native details elements, no JS needed ----------

	// ---------- sticky bar ----------
	var sbar = $("#sbar");
	var heroCta = root.querySelector(".hero .lpbtn");
	var buySection = $("#buy");
	if (sbar) {
		// .lp-patch-landing sets overflow-x:hidden (to clip decorative bleed
		// elements), which the CSS spec computes as overflow-y:auto too — and
		// iOS Safari treats that as a clip boundary for position:fixed
		// descendants, so the bar never stuck to the viewport there even
		// though it worked fine in Chrome. Moving it to a direct child of
		// document.body sidesteps that ancestor entirely. The custom properties its
		// CSS still reads (--muted/--line/--ink) are copied on first, since
		// .sbar's CSS is no longer scoped under .lp-patch-landing and can't
		// inherit them once detached.
		["--muted", "--line", "--ink"].forEach(function (name) {
			sbar.style.setProperty(name, getComputedStyle(root).getPropertyValue(name));
		});
		document.body.appendChild(sbar);
	}
	if (sbar && heroCta && buySection) {
		var ctaOut = false,
			buyIn = false;
		var upd = function () {
			sbar.classList.toggle("show", ctaOut && !buyIn);
		};
		new IntersectionObserver(function (entries) {
			ctaOut = !entries[0].isIntersecting;
			upd();
		}).observe(heroCta);
		new IntersectionObserver(
			function (entries) {
				buyIn = entries[0].isIntersecting;
				upd();
			},
			{ threshold: 0.15 }
		).observe(buySection);
	}

	// ---------- ship countdown + arrival date window (real dates, not typed) ----------
	// Computed from the shopper's own device clock, never a hardcoded
	// calendar date — those go stale the day after they're written (this
	// replaces an earlier version that just faked a "4h 12m" countdown with
	// no real cutoff behind it, and per-wrapper ship_arrival_window strings
	// that had to be hand-edited to stay accurate). ship_cutoff_hour /
	// ship_lead_min / ship_lead_max come from the root element's own data
	// attributes (see lp-patch-landing-template.liquid's matching render
	// params) so a product can tune its real cutoff/lead time without
	// touching this file.
	var timerEl = $("#shipTimer");
	var shipDayEl = $("[data-ship-day]");
	var shipArrivalEl = $("[data-ship-arrival]");
	var shipArrivalShortEl = $("[data-ship-arrival-short]");
	if (timerEl || shipDayEl || shipArrivalEl || shipArrivalShortEl) {
		var CUTOFF_HOUR = parseInt(root.getAttribute("data-ship-cutoff-hour"), 10);
		if (!(CUTOFF_HOUR >= 0 && CUTOFF_HOUR <= 23)) CUTOFF_HOUR = 14;
		var LEAD_MIN = parseInt(root.getAttribute("data-ship-lead-min"), 10) || 3;
		var LEAD_MAX = parseInt(root.getAttribute("data-ship-lead-max"), 10) || 8;
		var SHIP_LANG = document.documentElement.lang || undefined;

		var isWeekendDay = function (d) {
			var day = d.getDay();
			return day === 0 || day === 6;
		};
		var addBusinessDays = function (from, days) {
			var d = new Date(from.getTime());
			var added = 0;
			while (days > added) {
				d.setDate(d.getDate() + 1);
				if (!isWeekendDay(d)) added++;
			}
			return d;
		};
		var fmtLongDate = function (d) {
			try {
				return new Intl.DateTimeFormat(SHIP_LANG, { weekday: "short", day: "numeric", month: "short" }).format(d);
			} catch (e) {
				var wd = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][d.getDay()];
				var mo = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][d.getMonth()];
				return wd + " " + d.getDate() + " " + mo;
			}
		};
		var fmtShortDate = function (d) {
			try {
				return new Intl.DateTimeFormat(SHIP_LANG, { day: "numeric", month: "short" }).format(d);
			} catch (e) {
				var mo = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][d.getMonth()];
				return mo + " " + d.getDate();
			}
		};

		var renderShip = function () {
			var now = new Date();
			var todayCutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), CUTOFF_HOUR, 0, 0, 0);
			var shipsToday = !isWeekendDay(now) && todayCutoff > now;

			var shipDate, target;
			if (shipsToday) {
				shipDate = now;
				target = todayCutoff;
			} else {
				shipDate = addBusinessDays(now, 1);
				target = new Date(shipDate.getFullYear(), shipDate.getMonth(), shipDate.getDate(), CUTOFF_HOUR, 0, 0, 0);
			}

			if (timerEl) {
				var diff = Math.max(0, target - new Date());
				var h = Math.floor(diff / 3600000);
				var m = Math.floor((diff % 3600000) / 60000);
				timerEl.textContent = h + "h " + m + "m";
			}
			if (shipDayEl) {
				shipDayEl.textContent = shipsToday ? "ships today" : "ships next business day";
			}

			var arriveStart = addBusinessDays(shipDate, LEAD_MIN);
			var arriveEnd = addBusinessDays(shipDate, LEAD_MAX);
			if (shipArrivalEl) {
				shipArrivalEl.textContent = "Arrives " + fmtLongDate(arriveStart) + " to " + fmtLongDate(arriveEnd) + ".";
			}
			if (shipArrivalShortEl) {
				var sameMonth = arriveStart.getMonth() === arriveEnd.getMonth();
				var shortRange = sameMonth
					? fmtShortDate(arriveStart) + "-" + arriveEnd.getDate()
					: fmtShortDate(arriveStart) + " - " + fmtShortDate(arriveEnd);
				shipArrivalShortEl.textContent = "Arrives by " + shortRange;
			}
		};

		renderShip();
		setInterval(renderShip, 30000);
	}

	// ---------- video modal (gallery + video carousel share it) ----------
	var modal = $("#modal");
	var modalVideo = $("#modalVideo");
	var modalClose = $("#modalClose");
	function openModal(src) {
		if (!modal) return;
		if (galVideo && !galVideo.paused) {
			galVideo.pause();
		}
		if (src && modalVideo) {
			modalVideo.src = src;
			modalVideo.play().catch(function () {});
		}
		modal.classList.add("show");
		document.body.style.overflow = "hidden";
	}
	function closeModal() {
		if (!modal) return;
		modal.classList.remove("show");
		document.body.style.overflow = "";
		if (modalVideo) {
			modalVideo.pause();
			modalVideo.currentTime = 0;
		}
	}
	$$(".vid-card").forEach(function (card) {
		card.addEventListener("click", function () {
			var src = card.getAttribute("data-video");
			if (src) openModal(src);
		});
	});
	if (modalClose) modalClose.addEventListener("click", closeModal);
	if (modal)
		modal.addEventListener("click", function (e) {
			if (e.target === modal) closeModal();
		});
	document.addEventListener("keydown", function (e) {
		if (e.key === "Escape") closeModal();
	});

	// ---------- video carousel slider ----------
	var vidCarousel = $("#vidCarousel");
	var vidDotsContainer = vidCarousel ? vidCarousel.nextElementSibling : null;
	var vidDots = vidDotsContainer ? $$("span", vidDotsContainer) : [];

	if (vidCarousel && vidDots.length) {
		var vidCards = $$(".vid-card", vidCarousel);
		var currentIndex = 0;
		var isDown = false;
		var isDragging = false;
		var startX = 0;
		var scrollStart = 0;
		var isNavigating = false;
		var navTimeout = null;
		var slideTargets = [0];

		vidCarousel.style.scrollPaddingLeft = "0px";

		function getStep() {
			if (vidCards.length > 1) {
				return vidCards[1].offsetLeft - vidCards[0].offsetLeft;
			}
			return vidCards[0] ? vidCards[0].offsetWidth + 20 : 220;
		}

		function calculateSlideTargets() {
			var maxScroll = vidCarousel.scrollWidth - vidCarousel.clientWidth;
			if (0 >= maxScroll) return [0];

			var step = getStep();
			var targets = [0];
			var current = step;
			while (maxScroll - 20 > current) {
				targets.push(current);
				current += step;
			}
			targets.push(maxScroll);
			return targets;
		}

		function syncDots() {
			slideTargets = calculateSlideTargets();
			var numNeeded = slideTargets.length;

			if (1 >= numNeeded) {
				if (vidDotsContainer) vidDotsContainer.style.display = "none";
				return;
			}
			if (vidDotsContainer) vidDotsContainer.style.display = "flex";

			vidDots.forEach(function (dot, i) {
				if (numNeeded > i) {
					dot.style.display = "";
					dot.style.cursor = "pointer";
				} else {
					dot.style.display = "none";
				}
			});
			updateDots();
		}

		function getActiveIndex() {
			if (!slideTargets.length) return 0;
			var closestIdx = 0;
			var minDiff = Infinity;
			for (var i = 0; slideTargets.length > i; i++) {
				var diff = Math.abs(vidCarousel.scrollLeft - slideTargets[i]);
				if (minDiff > diff) {
					minDiff = diff;
					closestIdx = i;
				}
			}
			return closestIdx;
		}

		function updateDots(idx) {
			if (idx === undefined) {
				idx = getActiveIndex();
			}
			currentIndex = Math.max(0, Math.min(slideTargets.length - 1, idx));
			vidDots.forEach(function (d, i) {
				d.classList.toggle("on", i === currentIndex);
			});
		}

		function goTo(idx, smooth) {
			if (!slideTargets.length) return;
			idx = Math.max(0, Math.min(slideTargets.length - 1, idx));
			currentIndex = idx;
			var target = slideTargets[idx];

			isNavigating = true;
			updateDots(idx);

			vidCarousel.style.scrollSnapType = "none";
			vidCarousel.scrollTo({
				left: target,
				behavior: smooth !== false ? "smooth" : "auto"
			});

			clearTimeout(navTimeout);
			navTimeout = setTimeout(function () {
				vidCarousel.style.scrollSnapType = "";
				isNavigating = false;
				updateDots();
			}, 450);
		}

		vidDots.forEach(function (dot, i) {
			dot.addEventListener("click", function () {
				if (slideTargets.length > i) {
					goTo(i, true);
				}
			});
		});

		syncDots();
		window.addEventListener("resize", syncDots);

		var scrollT;
		vidCarousel.addEventListener("scroll", function () {
			if (!isDown && !isNavigating) {
				clearTimeout(scrollT);
				scrollT = setTimeout(function () {
					updateDots();
				}, 40);
			}
		});

		vidCarousel.style.cursor = "grab";

		vidCarousel.addEventListener("mousedown", function (e) {
			if (e.button !== 0) return;
			isDown = true;
			isDragging = false;
			var pageX = e.pageX != null ? e.pageX : e.clientX;
			startX = pageX - vidCarousel.offsetLeft;
			scrollStart = vidCarousel.scrollLeft;
			vidCarousel.style.cursor = "grabbing";
			vidCarousel.style.scrollBehavior = "auto";
			vidCarousel.style.scrollSnapType = "none";
		});

		window.addEventListener("mousemove", function (e) {
			if (!isDown) return;
			var pageX = e.pageX != null ? e.pageX : e.clientX;
			var x = pageX - vidCarousel.offsetLeft;
			var walk = x - startX;
			if (Math.abs(walk) > 4) {
				isDragging = true;
			}
			vidCarousel.scrollLeft = scrollStart - walk;
		});

		window.addEventListener("mouseup", function () {
			if (!isDown) return;
			isDown = false;
			vidCarousel.style.cursor = "grab";
			vidCarousel.style.scrollBehavior = "smooth";
			if (isDragging) {
				goTo(getActiveIndex(), true);
				setTimeout(function () {
					isDragging = false;
				}, 50);
			} else {
				vidCarousel.style.scrollSnapType = "";
			}
		});

		vidCarousel.addEventListener(
			"click",
			function (e) {
				if (isDragging) {
					e.preventDefault();
					e.stopPropagation();
				}
			},
			true
		);
	}
})();
